export interface FilterCondition {
  JoinType: ActionType
  SpecType: SpecType
  Spec: GenericSpec
}
export type GenericSpec =
  | GroupSpec
  | TextSpec
  | NumericSpec
  | DateSpec
  | DateTimeSpec
  | GeoSpec
  | DeviceSpec
  | SysSpec
  | EmailSpec
  | SmsSpec
  | SubscriptionSpec
  | ProfileSpec
  | FilterSpec
  | EngagementSpec
  | TrackingSpec

export interface FilterSpec {
  EvalMode: boolean
  ValuesEvalMode?: 'And' | 'Or'
  Values: number[]
}
export interface ProfileSpec {
  ProfileMatchOperator: ProfileMatch
  Dates: DatesDetails
}
export interface SubscriptionSpec {
  SubscriptionMatchOperator: SubscriptionMatch
  Dates: DatesDetails
}
export interface SmsSpec {
  SmsMatchOperator: SmsMatch
  Messages: number[]
  Tags: number[]
  Dates: DatesDetails
}
export interface EmailSpec {
  EmailMatchOperator: EmailMatch
  Messages: number[]
  Tags: number[]
  Links: string[]
  Dates: DatesDetails
}
export interface DeviceSpec {
  Code: number
  Precision: number
}
export interface SysSpec {
  Code: number
  Precision: number
}
export interface GeoSpec {
  GeoMatchOperator: GeoMatch
  Country: string
  Region: string
  Precision: number
}
export interface GroupSpec {
  GroupMatchOperator: GroupMatch
  Values: number[]
}
export interface EngagementSpec {
  EngagementMatchOperator: EngagementMatch
  Values: Array<0 | 1 | 2 | 3 | 4 | 5 | 6>
}
export interface TrackingSpec {
  Identifier: string
  TrackingActive: boolean
  TrackingMatchOperator: TrackingMatch
  Dates: DatesDetails
}
export interface TextSpec {
  /**
   * Email, MobileNumber, MobilePrefix, Contacts, SubscriptionDate, Field1...39
   */
  Identifier: string
  TextMatchOperator: TextMatch
  Values: string[]
}
export interface NumericSpec {
  Identifier: string
  Format: NumericFormat
  NumericMatchOperator: NumericMatch
  Values: number[]
}
export interface DateSpec {
  Identifier: string
  Format: DateFormat
  DateMatchOperator: DateMatch
  Values: string[]
}
export interface DateTimeSpec {
  Identifier: string
  Format: DateTimeFormat
  DateTimeMatchOperator: DateTimeMatch
  Values: string[]
}

export type ProfileFieldSpecs = TextSpec | NumericSpec | DateSpec | DateTimeSpec

export interface DatesDetails {
  Type: DatesType
  Details: DateRangeDetails | DaysDetails | HoursDetails
}
export interface DateRangeDetails {
  From?: string
  To?: string
}
export interface DaysDetails {
  Value: number
  Type: DatesDetailsType
}
export interface HoursDetails {
  Value: number
  Type: DatesDetailsType
}

export enum DatesType {
  DaysDetails = 'DaysDetails',
  HoursDetails = 'HoursDetails',
  DateRangeDetails = 'DateRangeDetails',
}
export enum SpecType {
  GroupSpec = 'GroupSpec',
  TextSpec = 'TextSpec',
  NumericSpec = 'NumericSpec',
  DateSpec = 'DateSpec',
  DateTimeSpec = 'DateTimeSpec',
  GeoSpec = 'GeoSpec',
  DeviceSpec = 'DeviceSpec',
  SysSpec = 'SysSpec',
  EmailSpec = 'EmailSpec',
  SmsSpec = 'SmsSpec',
  SubscriptionSpec = 'SubscriptionSpec',
  ProfileSpec = 'ProfileSpec',
  FilterSpec = 'FilterSpec',
  EngagementSpec = 'EngagementSpec',
  TrackingSpec = 'TrackingSpec',
}
export enum DatesDetailsType {
  Exactly = 'Exactly',
  Last = 'Last',
}
export enum TrackingMatch {
  TrackingAnytime = 'TrackingAnytime',
  TrackingDate = 'TrackingDate',
}
export enum ProfileMatch {
  UpdatedFromCurrentList = 'UpdatedFromCurrentList',
  UpdatedFromAnyList = 'UpdatedFromAnyList',
}
export enum SubscriptionMatch {
  SmsSubscribed = 'SmsSubscribed',
  SmsUnsubscribed = 'SmsUnsubscribed',
  EmailSubscribed = 'EmailSubscribed',
  EmailUnsubscribed = 'EmailUnsubscribed',
  EmailPending = 'EmailPending',
}
export enum SmsMatch {
  SmsSent = 'SmsSent',
  SmsNotSent = 'SmsNotSent',
  SmsSuccessfullySent = 'SmsSuccessfullySent',
  SmsNotReceived = 'SmsNotReceived',
  SmsExpired = 'SmsExpired',
  SmsRejected = 'SmsRejected',
}
export enum EmailMatch {
  EmailOpened = 'EmailOpened',
  EmailClicked = 'EmailClicked',
  EmailNotOpened = 'EmailNotOpened',
  EmailNotClicked = 'EmailNotClicked',
  EmailSent = 'EmailSent',
  EmailSuccessfullySent = 'EmailSuccessfullySent',
  EmailNotSent = 'EmailNotSent',
  EmailBouncedHB = 'EmailBouncedHB',
  EmailBouncedSB = 'EmailBouncedSB',
  EmailNotBouncedHB = 'EmailNotBouncedHB',
  EmailPerformedAtLeast1Action = 'EmailPerformedAtLeast1Action',
  EmailPerformedLessThan5Actions = 'EmailPerformedLessThan5Actions',
  EmailPerformedLessThan10Actions = 'EmailPerformedLessThan10Actions',
  EmailPerformed10OrMoreActions = 'EmailPerformed10OrMoreActions',
}
export enum GeoMatch {
  LocatedIn = 'LocatedIn',
  NotLocatedIn = 'NotLocatedIn',
}
export enum DateMatch {
  PlusXdaysEqualsToToday = 'PlusXdaysEqualsToToday',
  MinusXdaysEqualsToToday = 'MinusXdaysEqualsToToday',
  EqualToToday = 'EqualToToday',
  PlusXDaysEarlierThanToday = 'PlusXDaysEarlierThanToday',
  PlusXdaysLaterThanToday = 'PlusXdaysLaterThanToday',
  EqualTo = 'EqualTo',
  Before = 'Before',
  After = 'After',
  MinusXdaysEarlierThanToday = 'MinusXdaysEarlierThanToday',
  MinusXdaysLaterThanToday = 'MinusXdaysLaterThanToday',
}
export enum DateTimeMatch {
  PlusXHoursEqualsToNow = 'PlusXHoursEqualsToNow',
}
export enum TextMatch {
  TextPrefix = 'TextPrefix',
  TextNotPrefix = 'TextNotPrefix',
  TextSuffix = 'TextSuffix',
  TextNotSuffix = 'TextNotSuffix',
  TextContains = 'TextContains',
  TextNotContains = 'TextNotContains',
  TextIn = 'TextIn',
  TextNotIn = 'TextNotIn',
  TextNullEmpty = 'TextNullEmpty',
  TextNotNullNotEmpty = 'TextNotNullNotEmpty',
  TextSame = 'TextSame',
  TextGreater = 'TextGreater',
  TextGreaterEqual = 'TextGreaterEqual',
  TextLess = 'TextLess',
  TextLessEqual = 'TextLessEqual',
  TextDifferent = 'TextDifferent',
}
export enum NumericMatch {
  NumericSame = 'NumericSame',
  NumericGreater = 'NumericGreater',
  NumericGreaterEqual = 'NumericGreaterEqual',
  NumericLess = 'NumericLess',
  NumericLessEqual = 'NumericLessEqual',
  NumericDifferent = 'NumericDifferent',
}
export enum GroupMatch {
  BelongsTo = 'BelongsTo',
  NotBelongsTo = 'NotBelongsTo',
}
export enum NumericFormat {
  Decimal = 'Decimal',
  Integer = 'Integer',
}
/**
 * DateFormat1 = dd/MM/yyyy, DateFormat2 = dd/MM, DateFormat3 = MM/dd/yyyy, DateFormat4 = MM/dd, DateFormat5 = yyyy/MM/dd, DateFormat6 = yyyyMMdd, DateFormat7 = MMdd, DateFormat8 = yyyy-MM-dd
 */
export enum DateFormat {
  DateFormat1 = 'DateFormat1',
  DateFormat2 = 'DateFormat2',
  DateFormat3 = 'DateFormat3',
  DateFormat4 = 'DateFormat4',
  DateFormat5 = 'DateFormat5',
  DateFormat6 = 'DateFormat6',
  DateFormat7 = 'DateFormat7',
  DateFormat8 = 'DateFormat8',
}
/**
 * DateFormat9 = ISO8610
 */
export enum DateTimeFormat {
  DateFormat9 = 'DateFormat9',
}
export enum ActionType {
  Nil = 'Nil',
  And = 'And',
  Or = 'Or',
  AndNot = 'AndNot',
}
export enum ChannelType {
  All = 'All',
  Email = 'Email',
  Sms = 'Sms',
}
export enum UsedEntityType {
  UsedGroup = 'UsedGroup',
  UsedEmailMessage = 'UsedEmailMessage',
  UsedSmsMessage = 'UsedSmsMessage',
  UsedField = 'UsedField',
}
export enum SubscriptionType {
  Subscribed = 'Subscribed',
  Pending = 'Pending',
  Unsubscribed = 'Unsubscribed',
}
export enum ObjectType {
  Anagraphic = 'Anagraphic',
  Activity = 'Activity',
  Device = 'Device',
  Geolocation = 'Geolocation',
  MultiFilter = 'MultiFilter',
  MultiType = 'MultiType',
  Engagement = 'Engagement',
}
export enum EngagementMatch {
  EqualTo = 'EqualTo',
}
